import { Tooltip } from 'antd';
import React, { ReactNode, useEffect, useState } from 'react';
import { timeRules } from '../../utils/util';
import './index.scss';
interface LabelProps {
  text?: string;
  timeStamp?: string;
  tipInfo?: ReactNode;
  trigger?: AnyFunc;
}

const Label = (props: LabelProps) => {
  const delta = timeRules(props.timeStamp);
  const [, forceUpdate] = useState<any>(null);
  useEffect(() => {
    const timer = setInterval(() => {
      forceUpdate(Date.now());
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const renderLabelTag = () => {
    return (
      <div className="active-label-text">
        <span className="triangle"></span>
        {props.text && <span>{props.text}</span>}
        {delta && <span style={{ color: delta.color }}> {delta.timeStr}</span>}
      </div>
    );
  };

  return (
    <>
      {props.tipInfo ? (
        <Tooltip
          title={props.tipInfo}
          trigger="hover"
          onOpenChange={(open) => {
            props.trigger && props.trigger(open);
          }}
        >
          {renderLabelTag()}
        </Tooltip>
      ) : (
        renderLabelTag()
      )}
    </>
  );
};

export default React.memo(Label);
